<template>
  <div class="drawer" data-type="menu" data-position="left">
    <div class="menu-drawer">
      <div
        id="MenuDrawer-Overlay"
        class="drawer__overlay"
        @click="onClickCloseMenuDrawer()"
      ></div>
      <div
        class="drawer__inner"
        role="dialog"
        aria-modal="true"
        aria-label="Menu"
        tabindex="-1"
        @mouseenter="$emit('mouseenterMenuDrawer')"
        @mouseleave="$emit('mouseleaveMenuDrawer')"
      >
        <div class="drawer__header">
          <div class="drawer__heading inner-title">Menu</div>
          <button
            class="drawer__close"
            type="button"
            @click="onClickCloseMenuDrawer()"
            aria-label="Chiudi"
          >
            <base-icon name="close" width="12" height="12" />
          </button>
        </div>
        <div class="menu-wrapper">
          <sidebar-menu
            :class="['sidebar', { 'menu-item-lisapay--hidden': !hasLisapay }]"
            v-if="isLogged"
            :menu="final_menu"
            :collapsed="false"
            theme="white-theme"
            :disableHover="false"
            :hideToggle="true"
            :showOneChild="true"
            @item-click="onItemClick"
          >
            <!-- <template v-slot:header>
              <div :style="cssProps"></div>
              <div class="version text-sm-right">Version: 3.{{ cliVer }}</div>
            </template> -->

            <template v-slot:dropdown-icon>
              <!-- <span><b-icon icon="chevron-compact-right"></b-icon></span> -->
              <span
                ><base-icon name="chevron_right" width="16" height="16"
              /></span>
            </template>
          </sidebar-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import { isAdmin } from "@/utils/permissions";
import { canVerb, canModule } from "@/utils/permissions";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      collapsed: false,
      final_menu: [],
      menu: [
        {
          href: { name: "module.HOME" },
          title: "Home",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "house",
              style: "width: 20px; height: 20px;",
              title: "Home",
            },
          },
          disabled: false,
          menu_voice: "module.HOME",
        },
        {
          // href: { name: "module.PFOLIO" },
          title: "Portafoglio",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "wallet2",
              style: "width: 20px; height: 20px;",
              title: "Portafoglio",
            },
          },
          disabled: false,
          menu_voice: "module.PFOLIO",
          child: [
            {
              href: { name: "registries.index" },
              title: "Clienti",
              menu_voice: "module.PFOLIO",
              hideWhen: [],
            },
            {
              href: { name: "registry_groups.index" },
              title: "Gruppi",
              menu_voice: "module.PFOLIO",
              hideWhen: [],
            },
            {
              href: { name: "insurance_policies.index" },
              title: "Polizze",
              menu_voice: "module.PFOLIO",
              hideWhen: [],
            },
            {
              href: { name: "claims.index" },
              title: "Sinistri",
              menu_voice: "module.PFOLIO",
              hideWhen: [],
            },
            {
              href: { name: "agency_contacts.index0" },
              title: "Contatti",
              menu_voice: "module.PFOLIO",
              hideWhen: [],
            },
          ],
          menu_permissions: [
            {
              resource: "registries",
              verb: "index",
            },
            {
              resource: "registry_groups",
              verb: "index",
            },
            {
              resource: "insurance_policies",
              verb: "index",
            },
            {
              resource: "claims",
              verb: "index",
            },
            {
              resource: "agency_contacts",
              verb: "index",
            },
          ],
        },
        {
          href: { name: "module.TIT.TINS" },
          title: "Titoli",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "journals",
              style: "width: 20px; height: 20px;",
              title: "Titoli",
            },
          },
          disabled: false,
          menu_voice: "module.TIT",
          menu_permissions: [
            {
              resource: "insurance_ancillaries",
              verb: "index",
            },
          ],
        },
        {
          title: "Contabilità",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "calculator",
              style: "width: 20px; height: 20px;",
              title: "Contabilità",
            },
          },
          disabled: false,
          menu_voice: "module.CONT",
          menu_permissions: [
            {
              resource: "book_entries",
              verb: "index",
            },
            {
              resource: "agency_books",
              verb: "index",
            },
          ],
          child: [
            {
              href: { name: "module.CONT.FCAS" },
              title: "Foglio Cassa",
              menu_voice: "module.CONT",
              hideWhen: [],
            },
            {
              href: { name: "module.CONT.SOSP" },
              title: "Sospesi",
              menu_voice: "module.CONT",
              hideWhen: [],
            },
            {
              href: { name: "book_entries.index2" },
              title: "Acconti",
              menu_voice: "module.CONT",
              hideWhen: [],
            },
            {
              href: { name: "book_entries.index" },
              title: "Prospetto clienti e produttori",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.MOVV" },
              title: "Movimenti Vari",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.FQUA" },
              title: "Foglio Quadratura",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.STAT" },
              title: "Stats",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.CONP" },
              title: "Contabilità Produttori",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.CONC" },
              title: "Contabilità Compagnie",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "book_entries.index3" },
              title: "Collaborazioni orizzontali",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.COAS" },
              title: "Coassicurazioni",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.CONA" },
              title: "Contabilità Agenzia",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "module.CONT.ESCO" },
              title: "Estratti conto",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
            {
              href: { name: "movimenti_prima_nota.index0" },
              title: "Contabilità Giornaliera",
              menu_voice: "module.CONT",
              // hideWhen: ["production"],
            },
          ],
        },
        {
          href: { name: "module.QUIE.RICQ" },
          title: "Quietanzamento",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "receipt",
              style: "width: 20px; height: 20px;",
              title: "Quietanzamento",
            },
          },
          disabled: false,
          menu_voice: "module.QUIE",
          menu_permissions: [
            {
              resource: "insurance_payments",
              verb: "index",
            },
          ],
        },
        {
          href: { name: "module.CLOU" },
          title: "Documenti",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "file-earmark",
              style: "width: 20px; height: 20px;",
              title: "Documenti",
            },
          },
          disabled: false,
          menu_voice: "module.CLOU",
          // hideWhen: ["production"],
          /*child: [
            {
              href: { name: "module.CLOU" },
              title: "Ricerca Documenti",
            },
          ],*/
        },
        {
          href: { name: "report.index" },
          title: "Report",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "file-earmark-spreadsheet",
              style: "width: 20px; height: 20px;",
              title: "Report",
            },
          },
          disabled: false,
          menu_voice: "module.REPORT",
          /*child: [
            {
              href: { name: "report.index" },
              title: "Gestione Report",
              menu_voice: "module.PFOLIO.REPG",
            },
          ],*/
        },
        {
          title: "Analisi",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "file-bar-graph",
              style: "width: 20px; height: 20px;",
              title: "Analisi",
            },
          },
          disabled: false,
          menu_voice: "module.ANAY",
          menu_permissions: [
            {
              resource: "analyses",
              verb: "index",
            },
          ],
          child: [
            {
              href: { name: "analysis.index" },
              title: "Analisi",
              menu_voice: "module.ANAY",
            },
            {
              href: { name: "analysis_result.index" },
              title: "Risultati",
              menu_voice: "module.ANAY",
            },
            {
              href: { name: "analysis_data_crossing.index" },
              title: "Incrocio Dati",
              menu_voice: "module.ANAY",
            },
          ],
        },
        {
          href: { name: "importers.index" },
          title: "Importatori",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "file-arrow-down",
              style: "width: 20px; height: 20px;",
              title: "Import",
            },
          },
          disabled: false,
          menu_voice: "module.IMP",
          /* child: [
            {
              href: { name: "importers.index" },
              title: "Importatori",
              menu_voice: "module.IMP",
            },
          ],*/
        },
        {
          title: "LisaComunica",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "chat-text",
              style: "width: 20px; height: 20px;",
              title: "Comunicazioni",
            },
          },
          disabled: false,
          menu_voice: "module.COM",
          // hideWhen: ["production"],
          child: [
            {
              href: { name: "communication_procedures.index" },
              title: "Procedure",
            },
            {
              href: { name: "lisacomunica_template" },
              title: "Modelli",
            },
            {
              href: { name: "lisacomunica_log" },
              title: "Log",
            },
          ],
        },
        {
          title: "Log",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "file-text",
              style: "width: 20px; height: 20px;",
              title: "Log",
            },
          },
          disabled: false,
          menu_voice: "module.LOG",
          // hideWhen: ["production"],
          child: [
            // {
            //   href: { name: "module.LOG.LEMA" },
            //   title: "Email",
            //   menu_voice: "module.LOG",
            // },
            // {
            //   href: { name: "module.LOG.LSMS" },
            //   title: "Sms",
            //   menu_voice: "module.LOG",
            // },
            // {
            //   href: { name: "module.LOG.LIBR" },
            //   title: "Posta Ibrida",
            //   menu_voice: "module.LOG",
            // },
            {
              href: { name: "import" },
              title: "Import",
              menu_voice: "module.LOG",
            },
            // {
            //   href: { name: "broker_statement" },
            //   title: "Rendiconti",
            //   menu_voice: "module.LOG",
            // },
          ],
        },
        /* {
          title: "Priv-Easy",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "shield-lock",
              style: "width: 20px; height: 20px;",
              title: "Priv-Easy",
            },
          },
          disabled: false,
          menu_voice: "module.PEASY",
          menu_permissions: [
            {
              resource: "registries",
              verb: "index",
            },
          ],
          child: [
            {
              href: { name: "module.PEASY.PRIV" },
              title: "Clienti",
              menu_voice: "module.PEASY",
            },
          ],
        }, */
        // {
        //   title: "Cloud",
        //   icon: {
        //     element: "b-icon",
        //     attributes: {
        //       variant: "light",
        //       icon: "cloud",
        //       style: "width: 20px; height: 20px;",
        //       title: "Cloud",
        //     },
        //   },
        //   disabled: false,
        //   menu_voice: "module.CLOU",
        // },
        {
          href: { name: "sepa.index" },
          title: "SEPA",
          icon: {
            element: "span",
            class: "sepa-icon",
            attributes: {
              style: "width: 20px; height: 20px;",
              title: "SEPA",
            },
          },
          disabled: false,
          menu_voice: "module.PROF.SEPA",
          /*child: [
            {
              href: { name: "sepa.index" },
              title: "Gestione SEPA",
              menu_voice: "module.PROF.SEPA",
            },
          ],*/
        },
        {
          href: { name: "lisapay.index" },
          title: "Lisapay",
          icon: {
            element: "span",
            class: "lisapay-icon",
            attributes: {
              style: "width: 20px; height: 20px;",
              title: "Lisapay",
            },
          },
          disabled: false,
          /*child: [
            {
              href: { name: "sepa.index" },
              title: "Gestione SEPA",
              menu_voice: "module.PROF.SEPA",
            },
          ],*/
        },
        {
          href: { name: "fattutto.index" },
          title: "Fattutto",
          icon: {
            element: "span",
            class: "fattutto-icon",
            attributes: {
              style: "width: 20px; height: 20px;",
              title: "Fattutto",
            },
          },
          disabled: false,
          menu_voice: "module.FATT",
          menu_permissions: [
            {
              resource: "fattutto",
              verb: "send",
            },
            {
              resource: "fattutto",
              verb: "config",
            },
          ],
          /*child: [
            {
              href: { name: "sepa.index" },
              title: "Gestione SEPA",
              menu_voice: "module.PROF.SEPA",
            },
          ],*/
        },
        {
          href: { name: "module.PROF.CONFIG" },
          // la voce resta evidenziata anche nelle pagine dell'area:
          // sono i prefissi dei path definiti in router/profile.js
          alias: [
            "/agency-setups(.*)",
            "/bank-accounts(.*)",
            "/book-tags(.*)",
            "/cash-references(.*)",
            "/cash-treasuries(.*)",
            "/custom-attributes(.*)",
            "/emessage(.*)",
            "/insurer_participants(.*)",
            "/note-templates(.*)",
            "/profile-(.*)",
            "/settings(.*)",
            "/treasury-cash-reference(.*)",
            "/users(.*)",
          ],
          title: "Configurazione",
          icon: {
            element: "b-icon",
            attributes: {
              variant: "light",
              icon: "gear",
              style: "width: 20px; height: 20px;",
              title: "Configurazione",
            },
          },
          disabled: false,
          menu_voice: "module.PROF",
        },
      ],
    };
  },
  components: {
    BaseIcon,
  },
  computed: {
    ...mapGetters("sidebar", ["isNavClose"]),
    ...mapGetters("login_data", ["isLoginData"]),
    ...mapGetters("auth", ["isLogged", "permissions"]),
    hasLisapay() {
      return this.$store.state.auth.settings.attributables.LISAPAY === "Y"
        ? true
        : false;
    },
    // isAdmin() {
    //   let adminRoles = ["admin-agenzia", "super-admin", "admin-assistenza"];
    //   for (let i = 0; i < adminRoles.length; i++) {
    //     if (this.getRoles().includes(adminRoles[i])) {
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    // logo() {
    //   return this.isNavClose
    //     ? `url(${require("@/assets/logo_collapsed.png")})`
    //     : `url(${require("@/assets/logo_expanded.png")})`;
    // },
    // logoBckSize() {
    //   return this.isNavClose ? "50px" : "240px";
    // },
    // w() {
    //   return this.isNavClose ? "50px" : "240px";
    // },
    // h() {
    //   return "85px";
    // },
    // cssProps() {
    //   return {
    //     backgroundImage: this.logo,
    //     "background-repeat": "no-repeat",
    //     "background-size": this.logoBckSize,
    //     width: this.w,
    //     height: this.h,
    //   };
    // },
    // cliVer() {
    //   return process.env.VUE_APP_VERSION || "0";
    // },
  },
  methods: {
    isAdmin,
    canModule,
    onItemClick(event, item, node) {
      if (
        Object.prototype.hasOwnProperty.call(item, "child") &&
        item.child.length
      )
        return;
      this.onClickCloseMenuDrawer();
      console.log(`${event}, ${node}`);
    },
    onClickCloseMenuDrawer() {
      this.$emit("closeMenuDrawer");
    },
    ...mapActions("sidebar", ["saveNavbar"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapActions("tabs", { removeAllTabs: "removeAll" }),
    ...mapGetters("auth", {
      getRoles: "roles",
    }),
    // enableModule(code) {
    //   return this.permissions.includes(`${code}`);
    // },
    // enableResource(resource, verb = "index") {
    //   return this.permissions.includes(`resources.${resource}.${verb}`);
    // },
    setSubMenu(menu_voices) {
      menu_voices.child.forEach((sub_menu) => {
        let isHidden = false;
        switch (sub_menu.href.name) {
          case "users.index":
            isHidden = this.isAdmin ? false : true;
            break;
          case "bank_accounts.index":
            isHidden = canModule("module.PROF.SEPA") ? false : true;
            break;
          default:
            console.log("No submenu entry was found.");
        }
        this.$set(sub_menu, "hidden", isHidden);
      });
    },
    setChildren(menu_item) {
      const mode = process.env.NODE_ENV;
      if (!menu_item.child) return;
      menu_item.child.forEach((child) => {
        if (child.hideWhen && child.hideWhen.includes(mode)) {
          this.$set(child, "hidden", true);
        }
      });
    },
    skipModule(menu_item) {
      const mode = process.env.NODE_ENV;
      if (!menu_item.hideWhen) return false;
      return menu_item.hideWhen.includes(mode) ? true : false;
    },
    // atLeastOneEnableResource(permissions) {
    atLeastOneCanVerb(permissions) {
      let ret = permissions.length ? false : true;
      for (const p of permissions) {
        // ret ||= this.enableResource(p.resource, p.verb);
        ret ||= canVerb(p.resource, p.verb);
      }
      return ret;
    },
  },
  watch: {
    "$store.state.auth.permissions": {
      handler() {
        this.final_menu = [];
        // Object(this.menu).forEach((i) => {
        for (const i of this.menu) {
          if (i.menu_voice === "test" && process.env.VUE_APP_TEST == 1) {
            this.final_menu.push(i);
            continue;
          }
          if (!i.menu_voice) {
            this.final_menu.push(i);
          } else if (
            // (this.enableModule(i.menu_voice) ||
            (canModule(i.menu_voice) ||
              // this.enableResource(i.menu_voice)) &&
              canVerb(i.menu_voice, "index")) &&
            this.atLeastOneCanVerb(i.menu_permissions || [])
          ) {
            if (this.skipModule(i)) continue;
            this.setChildren(i);
            this.final_menu.push(i);
          } else {
            if (i.menu_voice === "module.REPORT") {
              if (canVerb("reports", "index")) {
                this.final_menu.push(i);
              }
            }
          }
          // riservata agli admin: la rimuovo solo se e' stata davvero
          // aggiunta, altrimenti il pop si porta via la voce precedente
          if (
            i.menu_voice === "module.PROF" &&
            !this.isAdmin() &&
            this.final_menu[this.final_menu.length - 1] === i
          ) {
            this.final_menu.pop();
          }
        }
      },
    },
    // TODO Aggiorno in maniera dinamica la lista delle voci di menù
    // "$store.state.sidebar.locked": {
    //   handler() {
    //     if (this.$store.state.sidebar.locked) {
    //       this.menu.forEach((element) => this.$set(element, "disabled", true));
    //     } else {
    //       this.menu.forEach((element) => this.$set(element, "disabled", false));
    //     }
    //   },
    // },
  },
  beforeMount() {
    console.debug("process.env.NODE_ENV = ", process.env.NODE_ENV);
  },
};
</script>
<style lang="scss" scoped>
// :deep(.version) {
//   position: absolute;
//   top: 2px;
//   left: 130px;
//   font-size: smaller;
// }
:deep(.sepa-icon) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='24' width='24'%3E%3Cpath d='M12 22.75C6.072 22.75 1.25 17.928 1.25 12S6.072 1.25 12 1.25c.723 0 1.446.072 2.149.215a.75.75 0 0 1 .586.884.75.75 0 0 1-.885.585c-.604-.123-1.228-.185-1.851-.185C6.899 2.75 2.75 6.899 2.75 12s4.149 9.25 9.25 9.25 9.25-4.149 9.25-9.25a9.23 9.23 0 0 0-.186-1.851.751.751 0 1 1 1.471-.299c.143.703.215 1.426.215 2.149 0 5.928-4.822 10.75-10.75 10.75zM22.745 6.489c-.012-.837-.055-2.634-.234-3.649h-.001a1.65 1.65 0 0 0-.368-.767c-.023-.033-.037-.071-.066-.101a1.71 1.71 0 0 0-.916-.484h0c-1.015-.18-2.812-.223-3.649-.234a.75.75 0 0 0-.02 1.5l2.569.159-3.087 3.053a.75.75 0 1 0 1.056 1.066l3.109-3.074.108 2.547h0c.006.414.348.75.762.744a.75.75 0 0 0 .739-.76h0zm-9.017 10.226c-1.79-.069-3.327-1.231-3.885-2.911h-.979c-.377 0-.684-.306-.684-.683s.307-.684.684-.684h.681l-.021-.434.021-.437h-.681c-.377 0-.684-.307-.684-.684s.307-.684.684-.684h.978a4.25 4.25 0 0 1 3.876-2.911h.001c.602 0 1.194.141 1.722.408.163.081.285.222.342.395a.68.68 0 0 1-.648.901c-.107 0-.209-.024-.305-.072-.342-.172-.723-.263-1.103-.263a2.82 2.82 0 0 0-2.398 1.543h2.015c.377 0 .683.307.683.684s-.306.684-.683.684h-2.426a3.73 3.73 0 0 0 0 .871h1.978c.377 0 .684.307.684.684s-.307.683-.684.683H11.33c.461.907 1.373 1.501 2.408 1.544.372 0 .753-.091 1.093-.263.096-.048.201-.073.306-.073a.68.68 0 0 1 .612.379c.082.163.095.349.037.522a.68.68 0 0 1-.343.396 3.81 3.81 0 0 1-1.707.407h-.006z' fill='gray'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 20px;
}
:deep(.fattutto-icon) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 110.963'%3E%3Cpath d='M145.973 53.242l-2.494-1.639-.157-3.007C142.05 24.262 124.853 4.773 100.97.598 98.535.172 90.277-.163 88.271.083c-15.844 1.94-28.316 9.018-36.745 20.854l-1.498 2.103-3.931-.138c-21.994-.775-40.355 13.359-45.08 34.7-5.708 25.787 13.296 51.286 39.555 53.072 7.305.497 89.091.308 92.589-.214 28.429-4.24 36.766-41.475 12.811-57.218zm-12.922 47.392c-3.011.621-90.833.69-94.448.073-21.971-3.744-34.807-26.854-26.174-47.12 6.688-15.7 22.926-23.883 39.884-20.099 1.428.319 2.626.546 2.662.506s.606-1.052 1.267-2.247c8.852-16.019 25.297-24.323 42.783-21.603 16.024 2.493 29.348 14.654 33.295 30.392 1.264 5.041 1.429 7.9.952 16.559l-.041.75 2.871 1.203c9.248 3.876 14.082 10.939 14.046 20.52-.039 10.455-6.952 18.973-17.098 21.067zM101.475 48.45H68.429l-1.208 13.158h8.111l-7.507 27.308h17.127l5.824-27.351h9.318l1.381-13.115zm2.329-8.24l2.071-14.042c-5.436-1.747-11.26-2.33-16.436-.841-6.625 1.905-8.777 12.763-9.512 17.86h16.695c.777-6.989 7.183-2.977 7.183-2.977z' fill='gray'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center center;
}
</style>
<style lang="scss" scoped>
.menu-wrapper {
  height: calc(100dvh - 57px);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}
#app.drawer-menu--open--light .drawer[data-type="menu"],
#app.drawer-menu--open .drawer[data-type="menu"] {
  visibility: visible;
}
#app.drawer-menu--open--light .drawer[data-type="menu"] {
  z-index: 9999;
}
#app.drawer-menu--open--light .drawer[data-type="menu"] .drawer__inner,
#app.drawer-menu--open .drawer[data-type="menu"] .drawer__inner {
  transform: translateX(0);
}
#app.drawer-menu--open--light .drawer[data-type="menu"] .drawer__inner {
  box-shadow: 1px 0 0 0 var(--gray-100);
}
#app .drawer[data-type="menu"] .drawer__close {
  opacity: 1;
  transition: opacity 0s linear 0.35s;
}
#app.drawer-menu--open--light .drawer[data-type="menu"] .drawer__close {
  transition: opacity 0s linear;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  touch-action: none;
  cursor: not-allowed;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
#app.drawer-menu--open .drawer[data-type="menu"] .drawer__overlay {
  opacity: 1;
}
.drawer {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  display: flex;
  visibility: hidden;
  background: 0;
  transition: visibility 200ms ease;
}
.drawer[data-position="left"] {
  justify-content: flex-start;
}
.drawer.is-empty {
  display: grid;
  grid-template-rows: 1fr;
  align-items: center;
  padding: 0;
}
// .drawer.active {
//   visibility: visible;
// }
// .drawer.active .drawer__inner {
//   transform: translateX(0);
// }
.drawer__overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(18, 18, 18, 0.5);
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.drawer__overlay:empty {
  display: block;
}
.drawer__inner {
  // width: calc(240px + 18px);
  width: 300px;
  max-width: 500px;
  height: 100vh;
  max-height: 100vh;
  margin-top: 0;
  border: 0;
  background: #fff;
  box-shadow: -1px 0 0 0 var(--gray-100);
  transition: all 0.3s ease-in-out;
}
.drawer[data-position="left"] .drawer__inner {
  transform: translateX(-100%);
}
.drawer__close {
  border: 0;
  background: 0;
}
.drawer__header {
  border-bottom: 1px solid var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  font-size: var(--font-size-lg);
  font-weight: 500;
}
.notifications-drawer-items.is-empty {
  height: 100%;
  padding: 0 1.5rem;
  background-color: rgb(var(--color-background));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.notifications-drawer-items.is-empty > p {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  margin: 0;
}
.drawer .notifications-drawer-items:not(.is-empty) {
  overflow-y: scroll;
  height: calc(100vh - 59px);
  padding: 20px;
}
.drawer .notification-item {
  padding-bottom: 20px;
  // border-bottom: 1px solid #eaeaea;
}
.drawer .notification-item ~ .notification-item {
  padding-top: 20px;
}
.drawer div > .notification-item:nth-of-type(even) {
  background: var(--gray-50);
  box-shadow: 0 0 0 100vmax var(--gray-50);
  clip-path: inset(0 -100vmax);
}
.drawer .notification-item .notification-item__title,
.drawer .notification-item .notification-item__desc {
  margin-bottom: 10px;
}
.drawer
  .notification-item:has(.notification-item__desc)
  .notification-item__title {
  margin-bottom: 0;
}
.drawer .notification-item .notification-item__title {
  grid-area: 1 / 1 / 2 / 3;
}
.drawer .notification-item .notification-item__desc {
  grid-area: 2 / 1 / 3 / 3;
}
.drawer .notification-item .custom-grid-wrapper {
  grid-template-columns: 125px minmax(auto, max-content);
  grid-row-gap: 5px;
  grid-column-gap: 18px;
  grid-area: 2 / 1 / 3 / 2;
}
.drawer .notification-item .notification-item__desc ~ .custom-grid-wrapper {
  grid-area: 3 / 1 / 4 / 2;
}
.drawer .notification-item__inner {
  display: grid;
  // grid-template-columns: repeat(2, 1fr);
  // grid-template-rows: repeat(2, 1fr);
  grid-template-columns: auto 38px;
  grid-auto-flow: row;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.drawer .notification-item__actions {
  grid-area: 2 / 2 / 3 / 3;
  align-self: flex-end;
  justify-self: flex-end;
}
.drawer .notification-item__desc ~ .notification-item__actions {
  grid-area: 3 / 2 / 4 / 3;
}
.drawer .notification-item__users ul {
  padding-left: 16px;
  margin: 0;
}
@media (hover: none) and (pointer: coarse) {
  .drawer .notifications-drawer-items:not(.is-empty) {
    -webkit-overflow-scrolling: touch;
  }
}
/* scoped: le voci le genera sidebar-menu, serve :deep per raggiungerle */
.menu-item-lisapay--hidden :deep(.vsm--item:has(.lisapay-icon)) {
  display: none;
  pointer-events: none;
  touch-action: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
:deep(.lisapay-icon) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M20.656 10.857c-1.79-.069-3.327-1.231-3.885-2.911h-.979c-.377 0-.684-.306-.684-.683s.307-.684.684-.684h.681l-.021-.434.021-.437h-.681c-.377 0-.684-.307-.684-.684s.307-.684.684-.684h.978a4.25 4.25 0 0 1 3.876-2.911h.001c.602 0 1.194.141 1.722.408.163.081.285.222.342.395a.68.68 0 0 1-.422.864c-.073.025-.149.037-.226.037-.107 0-.209-.024-.305-.072-.342-.172-.723-.263-1.103-.263a2.82 2.82 0 0 0-2.398 1.543h2.015c.377 0 .683.307.683.684s-.306.684-.683.684h-2.426a3.73 3.73 0 0 0 0 .871h1.978c.377 0 .684.307.684.684s-.307.683-.684.683h-1.566c.461.907 1.373 1.501 2.408 1.544.372 0 .753-.091 1.093-.263.096-.048.201-.073.306-.073a.68.68 0 0 1 .612.379c.082.163.095.349.037.522a.68.68 0 0 1-.343.396c-.53.267-1.114.406-1.707.407h-.006l-.002-.002zm1.846 3.757a1.86 1.86 0 0 0-1.606-.928c-.316 0-.626.083-.866.224l-2.746 1.114c-.512.256-1.057.256-2.373.256-1.277 0-3.267-.328-3.29-.331l-.095-.011h-.039c-.403 0-.743.288-.809.685-.036.216.014.434.141.612a.81.81 0 0 0 .535.332c.219.036 2.182.354 3.556.354 1.449 0 2.248 0 3.098-.426l2.79-1.137c.024-.014.049-.022.101-.022l.055.002c.054.015.098.049.125.096s.036.104.021.157-.049.099-.12.14l-4.631 2.883c-.009.006-.931.554-2.981.554-1.514 0-3.942-1.166-4.777-1.629-.148-.071-.958-.425-2.413-.425a.81.81 0 0 0-.55.22V12.05a.81.81 0 0 0 .55.22h2.739c.241.002 1.244-.037 1.651.268.817.612 1.588 1.191 2.375 1.191h2.054c.296 0 .446.106.45.106.155.153.36.237.578.237a.81.81 0 0 0 .579-.24c.156-.156.241-.362.241-.581a.81.81 0 0 0-.241-.579c-.097-.097-.633-.583-1.607-.583h-2.054c-.242-.002-.988-.561-1.391-.863-.817-.612-1.848-.595-2.635-.595H6.178a.81.81 0 0 0-.55.22V9.59c0-.83-.675-1.505-1.505-1.505H2.069a.82.82 0 1 0 0 1.64h1.919v11.084H2.069a.82.82 0 1 0 0 1.64h2.054a1.51 1.51 0 0 0 1.505-1.505v-2.409a.81.81 0 0 0 .55.22c.993 0 1.565.206 1.681.252.333.185 3.32 1.802 5.509 1.802 2.571 0 3.745-.733 3.858-.808l4.6-2.864c.427-.247.732-.645.859-1.12a1.83 1.83 0 0 0-.184-1.403z' fill='gray'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 20px;
}
</style>
